/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var BrokerEmailType;

(function (BrokerEmailType) {
  BrokerEmailType["QUOTE_NEW"] = "QUOTE_NEW";
  BrokerEmailType["QUOTE_QUOTED"] = "QUOTE_QUOTED";
  BrokerEmailType["QUOTE_UPDATED"] = "QUOTE_UPDATED";
  BrokerEmailType["QUOTE_REFERRED"] = "QUOTE_REFERRED";
  BrokerEmailType["QUOTE_REFERRED_APPROVED"] = "QUOTE_REFERRED_APPROVED";
  BrokerEmailType["QUOTE_REFERRED_DECLINED"] = "QUOTE_REFERRED_DECLINED";
  BrokerEmailType["POLICY_BIND"] = "POLICY_BIND";
  BrokerEmailType["QUOTE_DROPOUT_BEFORE_QUOTE"] = "quote_dropout_before_quote";
  BrokerEmailType["QUOTE_DROPOUT_BEFORE_PURCHASE"] = "quote_dropout_before_purchase";
})(BrokerEmailType || (BrokerEmailType = {}));